import { styled } from "@mui/material"

export const FormTitle = styled("div")({
  fontSize: "16px",
  lineHeight: "28px",
  fontWeight: 600,
  letterSpacing: 0,
  textAlign: "center",
  color: "#1A1A1A",
  margin: 0
})